import { InterInstance } from '@api/config';

export const getToken = async () => {
  try {
    const {
      data: { data },
    } = await InterInstance({
      method: 'post',
      url: `/authorization/token`,
      data: {
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET
       },
    });
    return data.access_token;
  } catch (e) {
    return e;
  }
};
